import { Truck } from "@boxicons/react";
export function Providers() {
    return (
        <section className="providers">
            <div className="providers-title">
                <h4>Proveedores</h4>
                <Truck className="i-truck"></Truck>
            </div>
            <div className="providers-list">
                <p>Proveedora de materiales electricos y de plomeria&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                Distribuidora CRISO&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                Works constructora&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                Magamoch&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                FVS constructora</p>
            </div>
        </section>
    )
}